import { useEffect, useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { chatAPI, notificationsAPI } from '../services/api';

/**
 * تعداد کل پیامهای خوانده نشده در همه اتاقهای کاربر را برمیگرداند.
 * هر ۸ ثانیه (و هنگام تغییر مسیر) پول میشود تا با پنل چت همگام بماند.
 */
export function useChatUnread() {
  const { isAuthenticated } = useAuth();
  const [unread, setUnread] = useState(0);

  useEffect(() => {
    if (!isAuthenticated) {
      setUnread(0);
      return undefined;
    }
    let active = true;

    const load = async () => {
      try {
        const [chatRes, notifRes] = await Promise.all([
          chatAPI.getChats().catch(() => null),
          // فاز ۷: customer-scope — badge مشتری فقط unreadهای customer-type را بشمارد
          notificationsAPI.list({ as: 'customer', is_read: false, page_size: 1 }).catch(() => null),
        ]);
        const data = chatRes?.data;
        const raw = Array.isArray(data)
          ? data
          : Array.isArray(data?.results)
            ? data.results
            : [];
        let total = raw.reduce((sum, room) => sum + (Number(room?.unread_count) || 0), 0);
        // اعلان‌های سیستمی خوانده‌نشده را هم اضافه کن (برای باکس «پیام‌های من» و فوتر)
        try {
          const nData = notifRes?.data;
          const nCount = Number(nData?.count);
          if (Number.isFinite(nCount)) total += nCount;
          else if (Array.isArray(nData?.results)) total += nData.results.filter((n) => !n?.is_read).length;
          else if (Array.isArray(nData)) total += nData.filter((n) => !n?.is_read).length;
        } catch {}
        if (active) setUnread(total);
      } catch (_) {
        // خطای شبکه باعث تغییر وضعیت نشود
      }
    };

    load();
    // P2 review fix: در تبِ مخفی پول نکن (۷-۸ درخواست/۸ثانیه × دو instance
    // بی‌مورد و باتری‌خور بود) — بازگشت به تب بلافاصله تازه‌سازی می‌کند.
    let id = null;
    const start = () => {
      if (id == null) id = setInterval(load, 8000);
    };
    const stop = () => {
      if (id != null) { clearInterval(id); id = null; }
    };
    const onVis = () => {
      if (document.visibilityState === 'visible') {
        start();
        load();
      } else {
        stop();
      }
    };
    if (document.visibilityState === 'visible') start();
    document.addEventListener('visibilitychange', onVis);
    return () => {
      active = false;
      stop();
      document.removeEventListener('visibilitychange', onVis);
    };
  }, [isAuthenticated]);

  return unread;
}
